import { connect } from "react-redux";
import BenchmarkHeatmap from "./BenchmarkHeatmap";


const mapStateToProps = (state) => ({
    fetchRaterHeatmapApi: state.BenchmarkFilteringReducer.fetchRaterHeatmapApi

});

const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkHeatmap);